import React from 'react'
import { func, bool, object, string } from 'prop-types'
import { Loader } from '@cobalt/cobalt-react-components'
import queryString from 'query-string'
import mapError from '../../utils/mapError/userManagement'
import { isAutomationAccount } from '../../config/feature-flags'
import { default as redirectToLogin } from '../../utils/redirect/redirectTo'
import {
  CONFIRM_ACCOUNT_TITLE,
  GENERIC_INVITATION_ERROR,
  ACCEPT_INVITATION_ACTION
} from '../../constants/ui.labels'
import {
  Base,
  ContentHeader,
  AcceptInvitationForm,
  Error,
  SecureForm,
  PasswordChangeFieldGroup,
  NoRecaptchaSecureForm
} from '../../components'
class AcceptInvitation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formData: {
        password: '',
        passwordConfirmation: '',
        isValid: false,
        invitationToken: null,
        error: null
      },
      isUserActive: false
    }
  }

  componentDidMount = () => {
    const { invitation_token: invitationToken } = queryString.parse(
      this.props.location.search
    )
    const { onLoad } = this.props
    this.setState({ formData: { ...this.state.formData, invitationToken } })
    onLoad({ invitationToken })
  }

  onFormChange = formData => this.setState({ formData })

  getErrorMessage = errorCode =>
    this.state.formData.error ||
    (errorCode && mapError(errorCode, GENERIC_INVITATION_ERROR)) ||
    null

  onFormSubmit = recaptchaResponse => {
    const {
      password,
      passwordConfirmation,
      invitationToken
    } = this.state.formData
    const { onConfirm } = this.props

    onConfirm({
      password,
      passwordConfirmation,
      invitationToken,
      recaptchaResponse: recaptchaResponse
    })
    this.setState({ displayToastError: true })
  }

  createToastError = errorCode => {
    return <Error message={this.getErrorMessage(errorCode)} />
  }

  renderForm = () => {
    const {
      confirmationError,
      name,
      email,
      siteKey,
      disabledForm,
      onExecuteRecaptcha
    } = this.props

    return (
      <React.Fragment>
        <ContentHeader title={CONFIRM_ACCOUNT_TITLE} />
        {(this.state.formData.error && !this.state.formData.isValid) ||
        this.state.displayToastError
          ? this.createToastError(confirmationError)
          : null}
        {!isAutomationAccount() && siteKey !== '' ? (
          <SecureForm
            onSubmit={this.onFormSubmit}
            onExecuteRecaptcha={onExecuteRecaptcha}
            siteKey={siteKey}
            submitLabel={ACCEPT_INVITATION_ACTION}
            isFormValid={this.state.formData.isValid}
            disabledForm={disabledForm}
          >
            <React.Fragment>
              <AcceptInvitationForm name={name} email={email} />
              <PasswordChangeFieldGroup
                formData={this.state.formData}
                onFormChange={this.onFormChange}
                disabledForm={disabledForm}
              />
            </React.Fragment>
          </SecureForm>
        ) : (
          <NoRecaptchaSecureForm
            onSubmit={this.onFormSubmit}
            submitLabel={ACCEPT_INVITATION_ACTION}
            isFormValid={this.state.formData.isValid}
            disabledForm={disabledForm}
          >
            <React.Fragment>
              <AcceptInvitationForm name={name} email={email} />
              <PasswordChangeFieldGroup
                formData={this.state.formData}
                onFormChange={this.onFormChange}
                disabledForm={disabledForm}
              />
            </React.Fragment>
          </NoRecaptchaSecureForm>
        )}
      </React.Fragment>
    )
  }

  renderLoading = () => (
    <div className="double-vertical-space">
      <Loader size="large" />
    </div>
  )

  renderContent = () => {
    const { loadingError, loaded, confirmed } = this.props

    if (confirmed) return redirectToLogin()
    if (loaded) return this.renderForm()
    if (loadingError) return redirectToLogin()

    return this.renderLoading()
  }

  render() {
    const content = this.renderContent()
    return <Base.Centered>{content}</Base.Centered>
  }
}

AcceptInvitation.propTypes = {
  siteKey: string.isRequired,
  isAutomationAccount: bool,
  confirmed: bool.isRequired,
  confirmationError: string.isRequired,
  loadingError: bool.isRequired,
  loaded: bool.isRequired,
  name: string.isRequired,
  email: string.isRequired,
  isUserActive: bool.isRequired,
  onLoad: func.isRequired,
  onConfirm: func.isRequired,
  onExecuteRecaptcha: func.isRequired,
  disabledForm: bool.isRequired,
  location: object
}

export default AcceptInvitation
